module.exports = "https://cdn-assessment.mathletics.com/app/121/assets/images/7d308a1129ead97566a6208a3bcdf883.svg";